export const MARKETING = 'posts';
export const MARKETING_POST = 'post';
export const REQUESTS = 'requests';
export const REQUEST_POST = 'request';
